export default __webpack_public_path__ + "static/media/loop-negative.c64c1e5c.svg";